import React from "react";

export type RadioProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  id?: string;
  name?: string;
  className?: string;
  labelClassName?: string;
};

export default function Radio({
  checked,
  onChange,
  label,
  id,
  name,
  className = "",
  labelClassName = "",
}: RadioProps) {
  const generatedId = React.useId();
  const inputId = id || generatedId;

  return (
    <label
      htmlFor={inputId}
      className={["inline-flex cursor-pointer items-center gap-2 text-left select-none", className]
        .filter(Boolean)
        .join(" ")}
    >
      <input
        id={inputId}
        name={name}
        type="radio"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        className="sr-only"
      />
      <span
        className={[
          "inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full border transition-colors",
          checked ? "border-brand-blue bg-white" : "border-light-grey bg-white",
        ].join(" ")}
      >
        {checked ? <span className="h-2 w-2 rounded-full bg-brand-blue" /> : null}
      </span>
      <span className={["text-sm text-dark-grey", labelClassName].filter(Boolean).join(" ")}>{label}</span>
    </label>
  );
}
